import { View, Text, StyleSheet, Pressable, useWindowDimensions } from 'react-native';
import { Border, Breakpoints, Color, FontFamily, FontSize, Padding } from '@/GlobalStyles';
import { Image } from 'expo-image';
import { useConfigurationContext } from '@/components/Contexts/ConfigurationContext';
import { ReactElement, useState } from 'react';
import { BaseDataItemType } from '@/components/DataTable/DataTable';

export type HeaderProps<T extends BaseDataItemType> = {
  title?: string;
  showListTypeSelector?: boolean;
  onSearchTextChange?: (text?: string) => void;
  headerSideComponent?: ReactElement;
  renderCard?: (
    item: T & { loading?: boolean },
    numberOfColumns: number,
    onItemPress?: (item: T) => void
  ) => ReactElement;
};

const Header = <T extends BaseDataItemType>(props: HeaderProps<T>) => {
  const {
    title,
    renderCard,
    showListTypeSelector = true,
    onSearchTextChange,
    headerSideComponent,
  } = props;

  const [showSearch, setShowSearch] = useState(false);

  const { listType, setListType } = useConfigurationContext();
  const { width } = useWindowDimensions();

  return (
    <View style={styles.titleContainer}>
      <Text style={[styles.title]}>{title}</Text>
      <View style={[styles.rightNav]}>
        {headerSideComponent}
        {showListTypeSelector && renderCard && width >= Breakpoints.tablet ? (
          <>
            <Pressable style={[styles.iconContainer]} onPress={() => setListType('list')}>
              <Image
                style={[styles.icon, listType === 'list' ? { opacity: 1 } : null]}
                contentFit="cover"
                source={require('@assets/icones/list.png')}
              />
            </Pressable>
            <Pressable style={styles.iconContainer} onPress={() => setListType('card')}>
              <Image
                style={[styles.icon, listType === 'card' ? { opacity: 1 } : null]}
                contentFit="cover"
                source={require('@assets/icones/cards.png')}
              />
            </Pressable>
          </>
        ) : null}
      </View>
    </View>
  );
};

export default Header;

const styles = StyleSheet.create({
  icon: {
    height: 22,
    width: 22,
    opacity: 0.3,
  },
  iconContainer: {
    padding: Padding.p_mini,
    height: 48,
    width: 48,
    backgroundColor: Color.BlancCasse,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: Border.br_11xl,
    flexDirection: 'row',
    marginLeft: 12,
  },
  titleContainer: {
    height: 53,
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    fontSize: FontSize.h3_size,
    color: Color.MainBleu,
    textAlign: 'left',
    fontFamily: FontFamily.labelMedium,
  },
  rightNav: {
    justifyContent: 'flex-end',
    flexDirection: 'row',
  },
});
